import { Controller } from "@hotwired/stimulus"

// Toggles the side-by-side PO preview pane on the Review Purchase Order
// page. State is persisted in localStorage so the operator's preference
// sticks across uploads. No-op when there's no preview blob (text-input
// POs render the form full-width and never show the toggle button).
const STORAGE_KEY = "po-preview-visible"

export default class extends Controller {
  static targets = ["layout", "previewPane", "toggleLabel", "toggleButton"]
  static values = { hasBlob: { type: Boolean, default: false } }

  connect() {
    if (!this.hasBlobValue) return

    const saved = localStorage.getItem(STORAGE_KEY)
    this.visible = saved === null ? true : saved === "true"
    this.render()
  }

  toggle(event) {
    event.preventDefault()
    this.visible = !this.visible
    localStorage.setItem(STORAGE_KEY, String(this.visible))
    this.render()
  }

  render() {
    if (!this.hasLayoutTarget) return

    if (this.visible) {
      this.layoutTarget.style.gridTemplateColumns = "minmax(360px, 1fr) 2fr"
      if (this.hasPreviewPaneTarget) this.previewPaneTarget.style.display = ""
      if (this.hasToggleLabelTarget) this.toggleLabelTarget.textContent = "Hide source"
    } else {
      this.layoutTarget.style.gridTemplateColumns = "1fr"
      if (this.hasPreviewPaneTarget) this.previewPaneTarget.style.display = "none"
      if (this.hasToggleLabelTarget) this.toggleLabelTarget.textContent = "Show source"
    }
  }
}
